(function () {
  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var realSubmit = document.querySelector('.product-form__submit');
    var trigger = bar.querySelector('[data-sticky-atc-trigger]');

    if (trigger && realSubmit) {
      trigger.addEventListener('click', function () {
        if (!realSubmit.disabled) {
          realSubmit.click();
        }
      });
    }

    // Stays visible from the moment the real Add to Cart button scrolls out of view
    // (above the viewport) all the way through the rest of the page, including the
    // footer. Only hides again once the visitor scrolls back up past the real button.
    if (realSubmit && 'IntersectionObserver' in window) {
      var submitObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('sticky-atc--visible');
            } else if (entry.boundingClientRect.top < 0) {
              bar.classList.add('sticky-atc--visible');
            } else {
              bar.classList.remove('sticky-atc--visible');
            }
          });
        },
        { threshold: 0 }
      );
      submitObserver.observe(realSubmit);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
